import { SidebarItem } from '@backstage/core-components';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline'
import BulletedListIcon from '@material-ui/icons/FormatListBulleted'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import Tooltip from '@material-ui/core/Tooltip'
import { permissionApiRef } from '@backstage/plugin-permission-react';
import { AuthorizeResult } from '@backstage/plugin-permission-common'
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/lib/useAsync';
import { 
  templateStepReadPermission,
  templateParameterReadPermission,
  actionExecutePermission
} from '@backstage/plugin-scaffolder-common/alpha'

export const LOCAL_NETWORK_HINT =
  'Could not reach the backend. Connect to VPN, then allow "Local network" / "Access other apps and services on this device" for this site via the site-permissions icon in the address bar, and reload.';

export const ScaffolderSidebarItem = () => {
  const permissionsApi = useApi(permissionApiRef);
  const identityApi = useApi(identityApiRef);
  const { loading, value: allowed, error } = useAsync(async () => {

    const { userEntityRef } = await identityApi.getBackstageIdentity()
    
    const promises = [ templateParameterReadPermission, templateStepReadPermission, actionExecutePermission ]
      .map((permission) => permissionsApi.authorize({ permission, resourceRef: userEntityRef}))

    return Promise.all(promises).then((results) => {
      for (let policyDecision of results) {
        if (policyDecision.result === AuthorizeResult.DENY) {
          return false
        }
      }
      return true
    });
  });
  
  if (error) {
    // eslint-disable-next-line no-console
    console.error('[Scaffolder Sidebar] Permission check failed:', error);
    return (
      <Tooltip title={LOCAL_NETWORK_HINT} placement="right">
        <SidebarItem
          text="Create unavailable"
          to="create"
          icon={ErrorOutlineIcon}
        />
      </Tooltip>
    );
  }

  if (!loading && allowed) {
    return (
      <>
        <SidebarItem
        text="Create..."
        to="create"
        icon={CreateComponentIcon}
        />
        <SidebarItem
          text="Scaffolder Logs"
          to="create/tasks"
          icon={BulletedListIcon}
        />
      </>
    );
  }
  return null;
};
